export enum UserType {
    admin = 1,
    Agent = 2,
    Workshop = 3,
    Client = 4,
    Gallery = 5,
    Supplier = 6
}
